import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { of, switchMap } from 'rxjs';
import { UserDetail } from '../models/UserDetail.model';
import { setUserDetailAction, setPermissionsAction } from '../ngrx/actions/global.actions';
import { AppState, selectUserDetail, selectPermissions } from '../ngrx/app.state';
import { AuthorizeService } from '../services/authorize.service';
import { StorageService } from '../services/storage.service';

export const GlobalRoutingGuard: CanActivateFn = (route, state) => {
  const store: Store<AppState> = inject(Store<AppState>);
  const authService: AuthorizeService = inject(AuthorizeService);
  const storageService: StorageService = inject(StorageService);

  let userString = storageService.getItem('user');
  let _user: UserDetail | undefined;
  if (userString) {
    _user = JSON.parse(userString);
  }

  let permissionsString = storageService.getItem('permissions');
  let _permissions: string[] | undefined;
  if (permissionsString) {
    _permissions = JSON.parse(permissionsString);
  }

  return authService.getUser().pipe(
    //load the user into the userSubject, and appState if needed and it exists in localStorage
    switchMap((user: UserDetail | null) => {
      if (!user && _user) {
        authService.setUserSubject(_user);
      }
      return store.select(selectUserDetail);
    }),
    switchMap((user: UserDetail | undefined) => {
      if (!user && _user) {
        store.dispatch(setUserDetailAction({ userDetail: _user }));
      }
      return store.select(selectPermissions);
    }),
    //load permissions into appState if needed and they exist in localStorage
    switchMap((permissions: string[] | undefined) => {
      if (!permissions && _permissions) {
        store.dispatch(setPermissionsAction({ permissions: _permissions }));
      }
      return of(true);
    }),
  );
};
